import Mark from "./Mark.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import MarkText from "../components/MarkText.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class LongMark extends Mark implements IMark
{
    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        this.markWidth = 36;
        this.markHeight = this.strokeThickness;

        if(this.targetTextField)
        {
            this.padding = this.adjustToScale(28)*this.multipleOfDefaultFontSize;
            if(this.targetTextField.text == "i")
            {
                this.padding = this.adjustToScale(12);
            }
            this.parentTarget = this.targetTextField;
            this.targetTextFieldStyle = this.targetTextField.style;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)/20;
            this.markWidth = 55*this.multipleOfDefaultFontSize;
            this.markX = this.targetTextField.width/2;
            if(this.hasAscender(this.targetTextField.text))
            {
                this.markY = this.targetTextField.height/2 - this.adjustToScale(88)*this.multipleOfDefaultFontSize;
            }
            else
            {
                this.markY = this.targetTextField.height/2 - this.adjustToScale(48)*this.multipleOfDefaultFontSize;
            }
        }
        else
        {
            this.markX = 0;
            this.markY = 0;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        let mark = new Graphics();
        mark.moveTo(0, 0);
        mark.lineTo(this.markWidth, 0);
        mark.stroke({width:this.strokeThickness, color:color, cap:"round"});
        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}